import { CreditCard, DotsThree, LockSimple, Warning } from 'phosphor-react'
import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate } from 'react-router'
import { getPedidoActivo } from '../../actions/pedidos'
import { checkPaymentStatus, getPaymentUrl } from '../../actions/redsys'
import i18n from '../../lang/idiomas'

Modal.setAppElement('#root')

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '60vw',
    textAlign: 'center',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: '0.3s',
  },
  overlay: {
    background: 'rgba(235, 235, 235, 0.2)',
    backdropFilter: 'blur(5px)',
    transition: '0.3s',
    zIndex: 99999,
  },
}

const PagarRedsys = ({ id_pedido }) => {
  const dispatch = useDispatch()

  const lockIcon = (
    <LockSimple
      color='coral'
      size={80}
    />
  )
  const errorIcon = (
    <Warning
      color='tomato'
      size={80}
    />
  )
  const successIcon = (
    <CreditCard
      color='palegreen'
      size={80}
    />
  )
  const dotsIcon = (
    <DotsThree
      color='rgb(110, 142, 248)'
      size={80}
    />
  )

  const [ds_SignatureVersion, setSignatureVersion] = useState(null)
  const [ds_MerchantParameters, setMerchantParameters] = useState(null)
  const [ds_Signature, setSignature] = useState(null)
  const [already_paid, setAlreadyPaid] = useState(false)
  const [fetching, setFetching] = useState(false)
  const [paymentPopupOpened, setOpenedPopup] = useState(false)
  const [verifiyingPayment, setVerifiyingPayment] = useState(false)
  const [paymentFailed, setPaymentFailed] = useState(false)
  const [paymentSuccess, setPaymentSuccess] = useState(false)
  const [messageToShow, setMessage] = useState(i18n.t('redsys.cevenoag'))
  const [iconToShow, setIcon] = useState(lockIcon)

  const [redirect, setRedirect] = useState(false)

  const pasarela = useSelector(state => state.formasPago?.forma_pago?.pasarela ?? null)
  const url = useSelector(state => state.formasPago?.forma_pago?.url_pasarela ?? null)
  const askCloseModal = () => {
    if (paymentPopupOpened) return
    setOpenedPopup(false)
  }

  const getPaymentInfo = async () => {
    setFetching(true)
    const data = await getPaymentUrl()
    setFetching(false)
    setSignature(data['Ds_Signature'])
    setSignatureVersion(data['Ds_SignatureVersion'])
    setMerchantParameters(data['Ds_MerchantParameters'])
    setAlreadyPaid(data['paid'])
  }

  const setError = message => {
    setIcon(errorIcon)
    setVerifiyingPayment(false)
    setPaymentFailed(true)
    setPaymentSuccess(false)
    setMessage(message)
  }

  const setSuccess = ({ numeroPedido, numeroSerie }) => {
    setIcon(successIcon)
    setVerifiyingPayment(false)
    setPaymentFailed(false)
    setPaymentSuccess(true)
    setMessage(
      i18n.t('resumen.resmokf1') +
        numeroSerie +
        '/' +
        numeroPedido +
        i18n.t('resumen.resmokf3') +
        '\n' +
        i18n.t('resumen.resmokf4'),
    )
  }

  const verifyPayment = async () => {
    let last_payment_log = null
    setVerifiyingPayment(true)
    setIcon(dotsIcon)
    setMessage(i18n.t('redsys.verifpag'))
    try {
      last_payment_log = await checkPaymentStatus(id_pedido)
    } catch (error) {
      setError(i18n.t('redsys.ercompag'))
      return
    }
    setVerifiyingPayment(false)
    if (last_payment_log.paid) {
      setSuccess({
        numeroPedido: last_payment_log.numero_pedido,
        numeroSerie: last_payment_log.numero_serie,
      })
      return
    }

    if (!last_payment_log.log[0]?.finished) {
      setError(i18n.t('redsys.vpagnoac'))
      return
    }

    setError(last_payment_log.log[0].message)
    return
  }

  const openWindowWithPost = async () => {
    let paymentForm = document.getElementById('payment-form-submit')
    const popup = window.open('', 'paymentWindow')
    paymentForm.submit()
    setOpenedPopup(true)
    setMessage(i18n.t('redsys.cevenoag'))
    setIcon(lockIcon)

    const interval = setInterval((stopInterval = () => clearInterval(interval)) => {
      if (popup.closed) {
        stopInterval()
        verifyPayment()
        getPaymentInfo()
      }
    }, 2000)
  }
  useEffect(() => {
    if (pasarela === 'REDSYS' && !fetching) getPaymentInfo()
  }, [pasarela])

  const finishButtonAction = () => {
    if (paymentFailed) {
      setOpenedPopup(false)
      setPaymentFailed(false)
      setVerifiyingPayment(false)
    } else {
      setOpenedPopup(false)
      setPaymentFailed(false)
      setVerifiyingPayment(false)
      setRedirect(true)
      dispatch(getPedidoActivo())
    }
  }

  return (
    <>
      <Modal
        isOpen={paymentPopupOpened}
        style={customStyles}
        onRequestClose={askCloseModal}
        contentLabel='Example Modal'>
        {iconToShow}
        <span style={{ fontSize: '1.4em', marginTop: '1em' }}>{messageToShow}</span>

        {!verifiyingPayment && (paymentFailed || paymentSuccess) ? (
          <button
            type='button'
            onClick={finishButtonAction}
            className='mt-3 btn btn-lg boton-pedido'>
            {i18n.t('general.aceptar')}
          </button>
        ) : (
          <></>
        )}
      </Modal>
      {pasarela === 'REDSYS' && ds_Signature && ds_SignatureVersion && ds_MerchantParameters ? (
        <>
          <button
            type='button'
            disabled={already_paid}
            onClick={openWindowWithPost}
            className='btn btn-lg boton-pedido'>
            {i18n.t('redsys.procpag')}
          </button>
          <form
            style={{ marginTop: 0 }}
            id='payment-form-submit'
            action={url}
            method='POST'
            target='paymentWindow'>
            <input
              type='hidden'
              name='Ds_SignatureVersion'
              value={ds_SignatureVersion}
            />
            <input
              type='hidden'
              name='Ds_MerchantParameters'
              value={ds_MerchantParameters}
            />
            <input
              type='hidden'
              name='Ds_Signature'
              value={ds_Signature}
            />
          </form>

          {redirect ? (
            <Navigate
              replace
              to='/'
            />
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  )
}

export default PagarRedsys
